/** Supabase suggestion_votes yokken destek oylarını saklar (PHP veya localStorage). */

const LOCAL_KEY = 'kitapcik_suggestion_votes_v1';
const PHP_ENDPOINT = '/suggestion-vote.php';

type VoteStore = Record<string, string[]>;

function readLocalStore(): VoteStore {
  try {
    const raw = localStorage.getItem(LOCAL_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw) as VoteStore;
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeLocalStore(store: VoteStore): void {
  localStorage.setItem(LOCAL_KEY, JSON.stringify(store));
}

export function getLocalVoteStats(
  suggestionIds: string[],
  visitorHash: string
): Map<string, { supportCount: number; supportedByMe: boolean }> {
  const store = readLocalStore();
  const stats = new Map<string, { supportCount: number; supportedByMe: boolean }>();

  for (const id of suggestionIds) {
    const voters = store[id] ?? [];
    stats.set(id, {
      supportCount: voters.length,
      supportedByMe: voters.includes(visitorHash),
    });
  }

  return stats;
}

export function addLocalSuggestionVote(suggestionId: string, visitorHash: string): boolean {
  const store = readLocalStore();
  const voters = store[suggestionId] ?? [];
  if (voters.includes(visitorHash)) return true;
  store[suggestionId] = [...voters, visitorHash];
  writeLocalStore(store);
  return true;
}

export async function fetchVoteStatsFromPhp(
  suggestionIds: string[],
  visitorHash: string
): Promise<Map<string, { supportCount: number; supportedByMe: boolean }> | null> {
  if (!suggestionIds.length) return new Map();

  const params = new URLSearchParams({
    ids: suggestionIds.join(','),
    visitor_hash: visitorHash,
  });

  try {
    const res = await fetch(`${PHP_ENDPOINT}?${params.toString()}`, {
      method: 'GET',
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    const body = (await res.json()) as {
      stats?: Record<string, { supportCount?: number; supportedByMe?: boolean }>;
    };
    const stats = new Map<string, { supportCount: number; supportedByMe: boolean }>();
    for (const id of suggestionIds) {
      const row = body.stats?.[id];
      stats.set(id, {
        supportCount: Math.max(0, Number(row?.supportCount ?? 0)),
        supportedByMe: Boolean(row?.supportedByMe),
      });
    }
    return stats;
  } catch {
    return null;
  }
}

export async function submitVoteToPhp(
  suggestionId: string,
  visitorHash: string
): Promise<{ ok: boolean; supportCount?: number; error?: string }> {
  try {
    const res = await fetch(PHP_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ suggestion_id: suggestionId, voter_hash: visitorHash }),
    });
    const body = (await res.json().catch(() => ({}))) as {
      ok?: boolean;
      supportCount?: number;
      error?: string;
    };
    if (res.ok && body.ok) {
      return { ok: true, supportCount: body.supportCount };
    }
    return { ok: false, error: body.error || `HTTP ${res.status}` };
  } catch {
    return { ok: false, error: 'Sunucuya bağlanılamadı' };
  }
}
